import React from 'react';
import { useOfferCountdown } from '../hooks/useOfferCountdown';
import { formatOfferDeadline } from '../utils/offer';
export function OfferCountdown() {
  const timeLeft = useOfferCountdown();
  if (!timeLeft) {
    return <div className="w-full rounded-2xl bg-rosa/10 px-6 py-5 text-center" data-id="element-155" data-mp="24y3lbdseqgm1">
        <p className="font-serif text-xl font-semibold text-rosa-dark" data-id="element-156" data-mp="28ynk0lsmpsaa">
          La oferta de lanzamiento finalizó
        </p>
        <p className="mt-1 text-sm text-tinta/65" data-id="element-157" data-mp="1c9pmivthvg9f">
          El precio actual es de 24 USD
        </p>
      </div>;
  }
  const blocks = [{
    value: timeLeft.days,
    label: 'Días'
  }, {
    value: timeLeft.hours,
    label: 'Hrs'
  }, {
    value: timeLeft.minutes,
    label: 'Min'
  }, {
    value: timeLeft.seconds,
    label: 'Seg'
  }];
  return <div className="w-full rounded-2xl bg-rosa/10 px-4 py-5 sm:px-6" data-id="element-158" data-mp="2wnqbeld2ezhz">
      <ul className="grid grid-cols-4 gap-2 sm:gap-3" data-id="element-159" data-mp="31m1m0yb6pe19">
        {blocks.map(block => <li key={block.label} className="rounded-xl bg-white/70 px-2 py-3 text-center" data-id="element-160" data-mp="26q2w5786ulxi">
            <span className="block font-serif text-3xl font-semibold leading-none tabular-nums text-rosa-dark sm:text-4xl" data-id="element-161" data-mp="21r9j1fwtcwxv">
              {String(block.value).padStart(2, '0')}
            </span>
            <span className="mt-1.5 block text-[10px] font-medium uppercase tracking-[0.16em] text-tinta/60" data-id="element-162" data-mp="1rs0syy52k2gs">
              {block.label}
            </span>
          </li>)}
      </ul>
      <p className="mt-4 text-center text-xs text-tinta/60 sm:text-sm" data-id="element-163" data-mp="1izgsds57vntb">
        Válido hasta el {formatOfferDeadline()} · Después el precio vuelve a 24
        USD
      </p>
    </div>;
}